<template>
	<div class="dc-post-grid-pagination-wrapper">
		<p>{{this.dctxt('showing')}} {{ $parent.results.length }} {{this.dctxt('of')}} {{ totalPosts }}</p>
		<button
			:class="[
				'dc-post-grid-load-more',
				'dc-button',
				'dc-button--has-title',
				'dc-button--has-icon',
				'dc-button--color-grey',
				{ 'dc-button--is-loading': loading },
			]"
			@click.stop.prevent="loadMore(currentPaged)"
			>{{ label }}<span class="icon icon-plus"></span
		></button>
	</div>
</template>

<script>
import LoadMore from '@dc-post-grid/layout/ui/LoadMore';
import { Translatable } from '@dc-post-grid/mixins/Translatable';
export default {
	extends: LoadMore,
	mixins: [
		Translatable
	],
};
</script>
